module.exports = __webpack_public_path__ + "static/media/fgn_3l.d7884b33.png";